import AddRegion from './AddRegion';

export default AddRegion;
